import * as VueToast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

export default defineNuxtPlugin({
  name: 'toast',

  parallel: true,

  setup({ vueApp }) {
    vueApp.use(VueToast.default, {
      position: VueToast.POSITION.TOP_RIGHT,
      timeout: 5000,
    })

    return {
      provide: {
        toast: VueToast.useToast(),
      },
    }
  },
})
